import { tailwindSheet, baseStyles } from '../../../_shared/styles.js';

const sheet = new CSSStyleSheet();
sheet.replaceSync(`
    :host {
        display: inline-block;
    }
    button {
        cursor: pointer;
    }
    button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    .label-text:empty {
        display: none;
    }
    .label-text:not(:empty) + slot[name="icon"] {
        margin-left: 0.5rem;
    }
`);

export default [tailwindSheet, baseStyles, sheet];
